import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { DataFlowSource } from './dataflow-source';
@Metamodel.model({
    name: 'powerquerysource',
    referable: true
})

export class PowerQuerySource extends DataFlowSource {
    public static readonly MODEL: IModel;
}
